export const PASSWORD = {
  MIN_LENGTH: 8,
  MAX_LENGTH: 64,
};

export const NICKNAME = {
  MIN_LENGTH: 3,
  MAX_LENGTH: 32,
};

export const COMPANY_NAME = {
  MIN_LENGTH: 3,
  MAX_LENGTH: 32,
};

export const TWO_FACTOR_CODE = {
  MIN_LENGTH: 6,
  MAX_LENGTH: 6,
};

export const REGEX = {
  EMAIL:
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};
